// extracted by mini-css-extract-plugin
export default {"root":"styles_root__1UIJn","linker":"styles_linker__XW6Rv"};